export default "__VITE_ASSET__JDn5GG4r__"